import React, {
  useEffect,
  useState,
  useContext
} from 'react';
import {
  Box,
  Container,
  Button,
  makeStyles
} from '@material-ui/core';
import { NavLink as RouterLink, Navigate } from 'react-router-dom';
import Page from 'src/components/Page';
import Tabelas from '../../shared/component/UIElements/Tabelas';
import { useHttpClient } from '../../hooks/http-hook';
import { AuthContext } from '../../shared/context/auth-context';
import ErrorMessage from '../../shared/component/UIElements/ErrorMessage';
import LoadingSpinner from '../../shared/component/UIElements/LoadingSpinner';
import Modal from '../../shared/component/Modal';

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  button: {
    color: 'white',
    paddingRight: '40px',
    paddingLeft: '40px',
    borderRadius: '23px',
    WebkitBorderRadius: '23px',
    MozBorderRadius: '23px'
  }
}));

const Classificacoes = () => {
  const auth = useContext(AuthContext);
  const {
    isLoading,
    error,
    sendRequest,
    clearError
  } = useHttpClient();
  const classes = useStyles();
  const [classificacoes, setClassificacoes] = useState([]);
  const [query, setQuery] = useState(null);
  const [navegar, setNavegar] = useState(false);
  const [remover, setRemover] = useState(false);

  const handleEdit = (qual) => {
    setNavegar(`classificacoes/${qual}`);
  };
  const fecharDeletar = () => {
    setRemover(false);
  };
  const abrirDeletar = (qual) => {
    setRemover(qual);
  };
  const handleDelete = async () => {
    try {
      const responseData = await sendRequest(
        `${process.env.REACT_APP_BACKEND_URL}/classificacoes/${remover}`,
        'DELETE',
        null,
        {
          'Content-Type': 'application/json',
          'x-access-token': auth.token
        }
      );
      console.log(responseData);
      if (responseData.sucesso) {
        setClassificacoes((prevState) => {
          const data = [...prevState.filter((item) => item.id !== remover)];
          setRemover(false);
          return data;
        });
      }
    } catch (err) {
      console.log(err);
    }
  };
  const handleBusca = (event) => {
    const searchLower = String(event.target.value).toLowerCase();
    if (String(searchLower).trim().length > 0) {
      const filtradas = classificacoes.filter((acerv) => String(acerv.nome.conteudo).toLowerCase().includes(searchLower));
      console.log(filtradas);
      setQuery(filtradas);
    } else {
      setQuery(null);
    }
  };
  useEffect(() => {
    const fetchClassificacoes = async () => {
      try {
        const responseData = await sendRequest(
          `${process.env.REACT_APP_BACKEND_URL}/classificacoes/`,
          'GET',
          null,
          {
            'Content-Type': 'application/json',
            'x-access-token': auth.token
          }
        );
        console.log(responseData);
        setClassificacoes(() => {
          const data = [...responseData.data.map((classificacao) => ({
            id: classificacao._id,
            nome: {
              conteudo: classificacao.nome,
              tipo: 'texto'
            },
            criacao: {
              conteudo: new Date(classificacao.createdDate).toLocaleString(),
              tipo: 'data'
            },
            edit: responseData.editar,
            delete: responseData.deletar
          }))];
          return data;
        });
      } catch (err) {
        console.log(err);
      }
    };
    fetchClassificacoes();
  }, [sendRequest, auth]);
  const LinkBehavior = React.forwardRef((props, ref) => (
    <RouterLink ref={ref} to="/app/classificacoes/nova" exact {...props} />
  ));
  if (navegar) {
    return <Navigate to={`/app/${navegar}`} />;
  }
  return (
    <Page
      className={classes.root}
      title="Classificações do Acervo"
    >
      <Container maxWidth={false}>
        <Box mt={3}>
          <Box
            display="flex"
            justifyContent="flex-start"
            pb={4}
          >
            {(auth.userPermission.permissoes.includes('all_admin') || auth.userPermission.nome === 'Gestor do Sistema') && (
              <Button
                color="secondary"
                variant="contained"
                component={LinkBehavior}
                className={classes.button}
              >
                Cadastrar nova Classificação
              </Button>
            )}
          </Box>
          {isLoading && <LoadingSpinner asOverlay />}
          <Tabelas
            data={query !== null ? query : classificacoes}
            estrutura={[
              { id: 'nome', tipo: 'avatar', nome: 'Nome' },
              { id: 'criacao', tipo: 'data', nome: 'Data de Cadastro' },
              { id: 'acoes', tipo: 'acoes', nome: 'Ações' },
            ]}
            edit={handleEdit}
            remove={abrirDeletar}
            busca={handleBusca}
            placeholder="Pesquisar situação do acervo"
          />
          <ErrorMessage error={error} onClear={clearError} />
        </Box>
      </Container>
      <Modal
        open={remover}
        close={fecharDeletar}
        title="Deseja realmente remover esta classificação do acervo?"
      >
        <Button
          color="primary"
          variant="contained"
          style={{ marginRight: '15px' }}
          onClick={handleDelete}
        >
          Remover Classificação
        </Button>
        <Button
          color="primary"
          variant="contained"
          onClick={fecharDeletar}
        >
          Cancelar
        </Button>
      </Modal>
    </Page>
  );
};

export default Classificacoes;
